import { AUTH_TOKEN_STORAGE_KEY } from "~/helpers/consts";
import { routes } from "~/router";
import { setFlashMessage } from "~/utils/flash/flash";

export function hardLogout(message?: string) {
  if (message) {
    setFlashMessage({ text: message, variant: "error", persist: true });
  }

  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  window.location.assign(routes.auth.login());
}
